/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2021-11-15 11:36:57
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-02-06 18:10:24
 */
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";

// 登录
const Login = () => import("@/views/Login/index");
Vue.use(VueRouter);

const routes = [
 
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      hidden: true,
    },
  },
];
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new VueRouter({
  routes,
});

/**
 * @description: 根据传入的路由重新生成一个路由配置
 * @Author: quwandong
 * @Date: 2022-05-18 15:27:45
 * @param routes 路由配置
 */
export function resetRouter(routes) {
  const createRouter = () => {
    new VueRouter({
      routes,
    });
  };

  router.matcher = createRouter.matcher;
}

// 路由拦截
router.beforeEach((to, from, next) => {
  if (to.matched[1]) {
    store.dispatch("saveHeadMenuPath", to.matched[1].path);
  }
  // 路由发生变化修改页面title
  if (to.meta.pageTitle) {
    document.title = `乡村振兴农业生产数字化管理平台${to.meta.pageTitle}`;
  }
  // 从本地中拿到loginStatus 用户信息
  let user = window.localStorage.getItem("user");
  // 设置2天后过期
  let time = 86400000 * 2; // 86400000是一天的毫秒数
  next();

  if (to.path == "/login") {
    next();
  } else {
    // 除了登入页，全部都要判断是否是登入状态
    if (user) {
      // 获取登入时的时间戳
      let oldTime = window.localStorage.getItem("loginTime");
      // 获取当前时间
      let thisTime = new Date().getTime();
      if (thisTime - oldTime >= time) {
        // 过期了,前往登入
        next({
          path: "/login",
          query: {
            redirect: to.fullPath,
          },
        });
      } else {
        next();
      }
    } else {
      // 否则去登入
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
});

export default router;
